export { default as Report } from './Report';



// WEBPACK FOOTER //
// ./src/components/Report/index.ts